"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_QUANTUM_EXPERIMENT_METRICS = void 0;

var _client = require("@apollo/client");

const GET_QUANTUM_EXPERIMENT_METRICS = _client.gql`
  query getExperimentMetrics(
    $applicationCoords: [String!]
    $experimentId: String!
    $asOfDenverDate: String!
    $variantAId: String!
    $variantBId: String!
    $observationStartDate: String
    $metricIds: [String!]
  ) {
    comparisonMetrics(
      experimentId: $experimentId
      asOfDenverDate: $asOfDenverDate
      variantAId: $variantAId
      variantBId: $variantBId
      applicationCoords: $applicationCoords
      observationStartDate: $observationStartDate
      metricIds: $metricIds
    ) {
      metricName
      metricId
      applicationCoords
      denverDate
      experimentId
      variantAId
      variantBId
      meanA
      meanB
      meanEffect
      meanEffectConfidenceInterval {
        lower
        upper
      }
      differenceInMeans
      meanDifferenceConfidenceInterval {
        lower
        upper
      }
      pValue
      subdimensionName
      subdimensionValue
      lowerConfidenceInterval
      upperConfidenceInterval
    }
    metricDefinitions {
      _id
      name
      displayName
      description
      calculation
      direction
      unit {
        name
        abbreviation
      }
    }
  }
`;
exports.GET_QUANTUM_EXPERIMENT_METRICS = GET_QUANTUM_EXPERIMENT_METRICS;